module.exports = __webpack_public_path__ + "static/36575D_2_0-d326bc2c2fc6efc073f7537663171179.woff";